import $ from "jquery";
export const setIsProcessingState = (isProcessing) => {
    const loadingSpinner = document.querySelector(".js-loading-spinner");
    if (loadingSpinner) {
        loadingSpinner.classList.toggle("u-hidden", isProcessing);
    }
};
export const loaderFeature = {
    init: function () {
        $(document).ajaxStart(function () {
            $(".js-loader").addClass("c-loader--active");
        });
        $(document).ajaxComplete(function () {
            $(".js-loader").removeClass("c-loader--active");
        });
    },
};
